import swal from 'sweetalert2';

class fetchClass {
    constructor(url, method, postData, contentType) {
        this.POST = 'POST';
        this.GET = 'GET';
        this.url = url;
        this.method = method;
        this.postData = postData;
        this.contentType = contentType;
        this.token = this.getToken();
    }

    getToken() {
        if (localStorage.getItem('token')) {
            return localStorage.getItem('token')
        }
    }

    httpMultipartPost() {

    }

    http() {
        let fetchMethod = null;

        switch(this.method) {
            case this.POST:
                fetchMethod = this.POST;
                break;
            case this.GET:
                fetchMethod = this.GET;
                break;
            default:
                const error = {
                    message: 'Error'
                };
                throw error;
        }

        let config = {
            method: fetchMethod, // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": contentType,
                "Cache-Control": "no-store, no-cache",
                "Authorization": "Bearer " + this.token
            },
            withCredentials: true,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer" // no-referrer, *client
        };

        switch(this.contentType) {
            case 'urlencoded':
                config.headers['Content-Type'] = "application/x-www-form-urlencoded";
                break;
            case 'form-data':
            // config.headers['Content-Type'] = "";
                // config.headers['Content-Type'] = "multipart/form-data";
                break;
            default:
                config.headers['Content-Type'] = "application/json";
        }

        if (this.postData) {
            if (this.contentType === 'form-data') {
                // console.log('form data', this.postData);
                config.body = this.postData;
            } else {
                config.body = JSON.stringify(this.postData);
            }
        }

        return fetch(this.url, config)
            .then(response => {
                const status = response.status;

                // console.log(response.ok, { status, response });

                if (response.ok) {
                    return response.json();
                } else {
                    if (status === 422) {
                        response.json().then(err => {
                            errorResponse(err);
                        });

                        return { status, message: 'Error' };
                    } else if (status === 401) {
                        localStorage.clear();
                        window.location.href = '/login';
                    } else {
                        const responseError = { 'status': status, message: 'Error' };
                        throw responseError;
                    }
                }
            }, error => {
                console.log('Fetch Error: ', error)
                return error;
            })
    }
}

const errorResponse = (error) => {
    let err = {status: 'error', message: 'network error'};

    if (error.response || error.validation) {
        let response = error.response ? error.response : error.validation;
        let errMessage = [];
    
        for (var ele in response) {
            for(var index = 0; index < response[ele].length; index++) {
                errMessage.push(response[ele][index]);
            }
        }

        err = errMessage.join("<br/>");
    }

    return swal.fire(
        'Error',
        err,
        'error'
    );
}

export default fetchClass;